import { Guid } from '@fitscovery/common/types';
import { CreateMemberInfo, Membership, MembershipSubscription } from '../models';

export class ImportMembers {
  static readonly type = '[Membership] ImportMembers';

  constructor(public formData: FormData) { }
}

export class CreateMember {
  static readonly type = '[Membership] CreateMember';

  constructor(public member: CreateMemberInfo) { }
}

export class ArchiveMember {
  static readonly type = '[Membership] ArchiveMember';

  constructor(public member: Membership) { }
}

export class UpdateMember {
  static readonly type = '[Membership] UpdateMember';

  constructor(public member: Membership) { }
}

export class StopMembershipRecurring {
  static readonly type = '[Membership] StopMembershipRecurring';

  constructor(public membership: Membership) { }
}

export class GetMembersByPartnerId {
  static readonly type = '[Membership] GetMembersByPartnerId';

  constructor(public partnerId: Guid) { }
}

export class GetMembershipWithHistory {
  static readonly type = '[Membership] GetMembershipWithHistory';

  constructor(public membershipId: Guid, public partnerId: Guid) { }
}

export class CreateMembershipSubscription {
  static readonly type = '[Membership] CreateMembershipSubscription';

  constructor(public membershipSubscription: MembershipSubscription) { }
}

export class UpdateMembershipSubscription {
  static readonly type = '[Membership] UpdateMembershipSubscription';

  constructor(public membershipSubscription: MembershipSubscription) { }
}

export class DeleteMembershipSubscription {
  static readonly type = '[Membership] DeleteMembershipSubscription';

  constructor(public membershipSubscriptionId: string, public partnerId: Guid) { }
}

export class GetMembershipSubscriptionById {
  static readonly type = '[Membership] GetMembershipSubscriptionById';

  constructor(public id: Guid) { }
}

export class GetMembershipSubscriptionsByPartnerId {
  static readonly type = '[Membership] GetMembershipSubscriptionsByPartnerId';

  constructor(public partnerId: Guid) { }
}

export class SetMembershipSubscriptionOrder {
  static readonly type = '[Membership] SetMembershipSubscriptionOrder';

  constructor(public id: Guid, public partnerId: Guid, public orderNumber: number) { }
}

export class GetEventActiveMembers {
  static readonly type = '[Membership] GetEventActiveMembers';
  
  constructor(public partnerId: Guid, public start: Date, public noOfTicket: number) { }
}

export class RemoveSelectedValidActiveMembers {
  static readonly type = '[Membership] RemoveSelectedValidActiveMembers';

  constructor() { }
}
